export enum LocalStorageKey {
    MATRIX_AUTH_KEY = 'MATRIX_AUTH_KEY',
    CLOSER_AUTH = 'CLOSER_AUTH',
    LANGUAGE = 'LANGUAGE',
    USER_WHATSAPP_NUMBER = 'USER_WHATSAPP_NUMBER',
    REMOTE_DEVICE_RECORD = 'REMOTE_DEVICE_RECORD',
    LOCAL_CONTACT_UPDATE_TIME = 'LOCAL_CONTACT_UPDATE_TIME'
}
